module.exports = __webpack_public_path__ + "static/lambcomf-7c28cfea4b36da5215c20935fcaa36cc.jpeg";